module.exports = __webpack_public_path__ + "static/media/people-icon.7782cf43.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/people-icon.svg
// module id = 877
// module chunks = 0 1